import { PieChart, Pie, ResponsiveContainer } from 'recharts'
import { PieChartData } from '../../interfaces/Indicator'
import { forwardRef, useEffect, useState } from 'react'
import { colors } from '../../utils/colors'
import ReferencesMapper from '../Mappers/ReferencesMapper'
import NotDataDisplay from '../Cards/NotDataDisplay'
import { messages } from '../../utils/const'

type ChartData = {
    name: string;
} & Record<string, number | string>;

const PieCharts = forwardRef<HTMLDivElement, { data: PieChartData[], errorsNoData: boolean }>(({ data, errorsNoData }, ref) => {
    const [chartData, setChartData] = useState<PieChartData[] | null>(null);

    useEffect(() => {
        if (data.length) {
            const firstEntry = data[0] as ChartData;
            const categories = Object.keys(firstEntry).filter(key => key !== 'name');

            const formattedData: PieChartData[] = categories.map((category, index) => ({
                name: category,
                value: Math.round(data.reduce((sum, entry) => {
                    const val = (entry as ChartData)[category];
                    return sum + (typeof val === 'number' ? val : 0);
                }, 0)),
                fill: colors[index % colors.length]
            }));

            setChartData(formattedData);
        }
    }, [data]);

    return (
        <>
            <ResponsiveContainer width="100%" height="100%" ref={ref}>
                <PieChart>
                    {
                        chartData?.map((entry, index) => (
                            <Pie
                                dataKey="value"
                                isAnimationActive={true}
                                data={chartData}
                                cx="50%"
                                cy="50%"
                                outerRadius="60%"
                                label
                                aria-label={entry.name}
                                key={index}
                            />
                        ))
                    }
                </PieChart>
            </ResponsiveContainer>
            <div className='relative bottom-[50px]'>
                <ReferencesMapper data={chartData ?? []} />
            </div>
            {errorsNoData ? <NotDataDisplay message={messages.chart} /> : null}
        </>
    );
})

export default PieCharts;
